export default "<p>\r\n  version-parent-app-list works!\r\n</p>\r\n"